import Create from './create';

export default class Build {
	constructor(targetNode) {
		this.targetNode = targetNode;
		this.termIds = this.targetNode.getAttribute('data-select-filters');
		this.resourceType = this.targetNode.getAttribute('data-resource-type');
		this.viewMoreBtn = document.querySelector('.em-content-category__view-more');
		this.viewMoreBtn.addEventListener('click', this.handleViewMoreButton);
		this.page = 0;
		this.maxPageCount = 0;

		// Builds out page resource items on load.
		const setCategoryData = new Create(this.resourceType);

		// Mutation Observer to check when filtered Ids change.
		const callback = () => {
			this.termIds = this.targetNode.getAttribute('data-select-filters');
			setCategoryData.setPaginationType(this.termIds === '' ? 1 : 2);
			setCategoryData.setResults(this.termIds);
		};
		const observer = new MutationObserver(callback);
		observer.observe(this.targetNode, {
			attributes: true,
			childList: false,
			subTree: false,
		});

		/**
		 * Add terms on Page Load.
		 */
		setCategoryData.setPaginationType(this.termIds === '' ? 1 : 2);
		setCategoryData.setResults(this.termIds);
	}

	/**
	 * Handles view more button click event.
	 */
	handleViewMoreButton = (e) => {
		const { target } = e;
		target.innerText = 'Loading';
		target.classList.add('loading');
		let counter = 0;
		const loadingAnimation = setInterval(() => {
			counter++;
			switch (counter) {
				case 1:
					target.innerText = 'Loading.';
					break;
				case 2:
					target.innerText = 'Loading..';
					break;
				case 3:
					target.innerText = 'Loading...';
					break;
				default:
					target.innerText = 'Loading';
					counter = 0;
					break;
			}
		}, 300);

		const { count, page, type } = target.dataset;
		const currentPage = parseInt(page);
		this.termIds = this.targetNode.getAttribute('data-select-filters');
		this.setMaxPageCount(count);
		target.setAttribute('data-max-count', this.maxPageCount);

		// Append new result set.
		const moreCategoryData = new Create(this.resourceType);
		moreCategoryData.appendResults(this.maxPageCount, currentPage, type, this.termIds);
		clearInterval(loadingAnimation);
	}

	/**
	 * Helps determine how many pages of content we have.
	 */
	setMaxPageCount(count) {
		const range = 16;
		const basePageCount = Math.floor(count / range);
		const otherPageCount = range % count > 0 ? 1 : 0;
		this.maxPageCount = basePageCount + otherPageCount;
	}
}
